import { Action } from '../decorator/log';
import Base from './BaseStore';
import Vue from 'vue';
import { getEntityType } from '../utils/util';
import DetailStore from './DetailStore';
import errorHandler from './errorHandler';

import mockAjax from './mock/ajax.mock.js';
let pathPrefix = null;
if ($foodConfig.mode === 'ces') {
    pathPrefix = '/brain-api/ces';
} else {
    pathPrefix = '/brain-api';
}
interface SearchStoreInterface {
    [propName: string]: any;
    searchItem: SearchItem;
}

interface SearchItem {
    [propName: string]: any;
    subjectId?: string;
    className: string;
    filterCity: any;
    entityType: 'user' | 'poi';
}

class SearchStore extends Base {
    state: SearchStoreInterface = {
        count: 1,
        searchItem: {} as SearchItem,
        searchList: [] as Array<any>,
        historyList: [] as Array<any>,
        searchHistoryList: [] as Array<any>,
        filterCity: undefined,
        financeSearchStr: ''
    };

    @Action changeFilterCity(city) {
        this.state.filterCity = city;
    }

    @Action addHistory(item) {
        let list = this.state.historyList;
        list.push(item);
        list = list.reverse();
        let subMap = {};
        list = list.filter((_) => {
            if (!subMap[_.subjectId]) {
                subMap[_.subjectId] = true;
                return true;
            }
        });
        list = list.slice(0, 5);
        list = list.reverse();
        this.state.historyList = list;
    }

    @Action addSearchHistory(item) {
        if (!localStorage.getItem('brainHistory')) {
            this.state.searchHistoryList = [];
        } else {
            let brainHistory = localStorage.getItem('brainHistory');
            this.state.searchHistoryList = JSON.parse(brainHistory);
        }
        let list = this.state.searchHistoryList;
        list.unshift(item);
        let subMap = {};
        list = list.filter((_) => {
            if (!subMap[_.subjectId]) {
                subMap[_.subjectId] = true;
                return true;
            }
        });
        list = list.slice(0, 10);
        // list = list.reverse();
        this.state.searchHistoryList = list;
        localStorage.setItem('brainHistory', JSON.stringify(list));
    }

    @Action deleteSearchHistory(index) {
        this.state.searchHistoryList.splice(index, 1);
        localStorage.setItem('brainHistory', JSON.stringify(this.state.searchHistoryList));
    }

    @Action setSearchItem(searchItem) {
        // TODO 搜索结果为空处理
        this.addHistory(searchItem);

        this.addSearchHistory(searchItem);

        // className数据清洗处理
        if (Array.isArray(searchItem.className)) {
            searchItem.className = searchItem.className[0];
        }

        searchItem.entityType = getEntityType(searchItem.customType || searchItem.className || searchItem.type);
        !searchItem.entityType && alert('数据出现错误');

        this.state.searchItem = searchItem;
    }

    @Action clearSuggest() {
        this.state.searchList = [];
        this.state.filterCity = undefined;
    }

    @Action clearSearchList() {
        this.state.searchList = [];
    }

    @Action
    async suggest({ str, city }: any) {
        let url = `${pathPrefix}/v1/searchSubjectId?id=${str}`;
        city && (url += `&city=${city}`);
        try {
            let res = await this.$api({
                path: url,
                method: 'get',
                params: {}
            });
            this.state.searchList = res.data;
            // debugger
        } catch (e) {
            let doNext = errorHandler(e, '搜索推荐出现错误');
        }
    }

    async searchCES (searchStr, isSetList = true, isQuick = false, city?) {
        try {
            let res;
            if (mockAjax[searchStr]) {
                res = mockAjax[searchStr];
            } else {
                let url = `${pathPrefix}/v1/searchSubjectId?id=${searchStr}`;

                if (!city) {
                    this.state.filterCity && (url += `&city=${this.state.filterCity}`);
                } else {
                    url +=`&city=${city}`
                }

                res = await this.$api({
                    path: url,
                    method: 'get', params: {}
                });
                if (searchStr === '海底捞') {
                    res.data = res.data.slice(1);
                }
            }
            city && (this.state.filterCity = city);
            let searchItem = res.data[0];
            if (!searchItem) {
                return void 0;
            }

            // 只有第一次默认poi 才触发，其他搜索词不触发，选中后才触发
            if (!this.state.searchItem.subjectId || isQuick) {
                this.addHistory(searchItem);
                this.setSearchItem(searchItem);
            }
            if (isSetList) {
                this.state.searchList = res.data;
            }
            return searchItem;
        } catch (e) {
            let doNext = errorHandler(e, '搜索出现错误');
        }
    }

    // 不是sug 是确定要搜索的内容了 啊 其实和sug很像的
    // @Action
    // async search(searchStr) {
    //     try {
    //         let res = await this.$api({
    //             path: `${pathPrefix}/v1/getSubjectId?propertyValue=${searchStr}`,
    //             method: 'get',
    //             params: {}
    //         });

    //         if (res.code === 403) {
    //             DetailStore.changeAccess(403);
    //             return res;
    //         }
    //         DetailStore.changeAccess(200);
    //         let searchItem = res.data[0];
    //         if (!searchItem) {
    //             // hack 登陆时序
    //             // Vue.prototype.$message.error('您搜索的内容不存在');
    //             return void 0;
    //         }
    //         this.addHistory(searchItem);
    //         this.setSearchItem(searchItem);
    //         return this.state;
    //     } catch (e) {
    //         Vue.prototype.$message.error('搜索出现错误' + e);
    //     }
    //     return this.state;
    // }
}

const search = new SearchStore();
export default search;
